import { assertNever } from '../robowhale/utils/assert-never'

export const PLATFORMS = [
	'dummy', //
	'yandex',
	'vk',
	'playgama',
	'aeroflot',
] as const

export type Platform = (typeof PLATFORMS)[number]

export function isPlatform(value: string): value is Platform {
	return PLATFORMS.includes(value as Platform)
}

export function detectPlatform(): Platform {
	const { host, hash, search } = window.location

	// URL param overrides the detected platform
	const urlPlatform = new URLSearchParams(search).get('platform')
	if (urlPlatform && isPlatform(urlPlatform)) {
		return urlPlatform
	}

	const bodyPlatform = document.body?.dataset?.platform
	if (bodyPlatform && isPlatform(bodyPlatform)) {
		return bodyPlatform
	}

	const yaHosts = ['yandex', 'playhop', 'allwebgames', 'yango', 'juegocasa', 'gametok', 'wowspiele']
	if (host.includes('yandex') || yaHosts.some((yaHost) => hash.includes(yaHost))) {
		return 'yandex'
	}

	const vkParams = new URLSearchParams(search)
	if (vkParams.has('vk_access_token_settings') || vkParams.has('vk_api_id') || vkParams.has('vk_user_id')) {
		return 'vk'
	}

	return 'dummy'
}

export function platformTag(platform: Platform) {
	switch (platform) {
		case 'dummy':
			return 'dummy'
		case 'yandex':
			return 'ya'
		case 'vk':
			return 'vk'
		case 'playgama':
			return 'playgama'
		case 'aeroflot':
			return 'aeroflot'
		default:
			assertNever(platform)
	}
}
